import React, { useEffect } from 'react'
import ProfileDetails from '../../components/profileDetails'
import Text from '../../components/text'
import { useAuth } from '../../core/AuthContext'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { TOAST_DUCK } from '../../core/actions'
import { BUYER_LINK } from '../../core/constants'
import * as styles from './Financier.css'
import { fetchFinancierAction } from './FinancierDuck'

export const Financier = () => {
  const { logout } = useAuth()
  const { authAxios } = useAxios()
  const {
    financierState: { financier },
  } = useGlobal()
  const { financierDispatch, documentsDispatch, toastDispatch } = useGlobalDispatch()

  const handleCopyReferral = () => {
    toastDispatch({
      type: TOAST_DUCK.SEND_TOAST,
      payload: { message: `Copied your referral message to clipboard` },
    })
    navigator.clipboard.writeText(
      `Hey, Use my referral code to invest in Income Bazaar and earn around 12% + extra 1% returns\nhttps://${BUYER_LINK}/register/${financier?.referralCode}`
    )
  }

  useEffect(() => {
    fetchFinancierAction()(authAxios, financierDispatch, documentsDispatch)
  }, [])

  return (
    <div className={styles.page}>
      <div className={styles.pagehead}>
        <Text size='1.7' color='var(--ib-ink)' bold className={styles.pageTitle}>
          Profile
        </Text>
      </div>

      {financier && (
        <ProfileDetails financier={financier} logout={logout} handleCopyReferral={handleCopyReferral} />
      )}
    </div>
  )
}
